const config  =  {
    API_HOST: '/api',
    API_PROXY: 'https://obsmoana.com:9090/proxy?url=http://api-uat.sbremit.co.uk'
}

export default config;